import { Grid, AspectRatio, Box } from '@chakra-ui/react'
import Image from 'next/image'

import { WidgetProps } from '../../types'

function IconWidget({
  text,
  image,
  index,
  isReverse,
}: WidgetProps): React.ReactElement {
  return (
    <Grid
      spacing={{ base: 4, sm: 6 }}
      sx={{
        alignItems: { base: 'center', sm: 'flex-start', md: 'center' },
        gridTemplateColumns: { base: '1fr', sm: 'max-content 1fr' },
        gridGap: { base: 4, sm: 6 },
        backgroundColor: index
          ? index % 2 === 0
            ? isReverse
              ? 'gray.50'
              : 'primary.10'
            : isReverse
            ? 'primary.10'
            : 'gray.50'
          : 'transparent',
        padding: '24px',
        borderRadius: '8px',
      }}
    >
      <Box
        sx={{
          alignSelf: 'baseline',
          m: '0 auto',
        }}
      >
        <AspectRatio
          ratio={1}
          sx={{
            w: '108px',
          }}
        >
          {image && <Image src={image} alt="" layout="fill" />}
        </AspectRatio>
      </Box>
      <Box
        sx={{
          fontSize: { base: 'md', sm: 'lg' },
          flex: '1 1 auto',
          w: 'full',
        }}
      >
        {text}
      </Box>
    </Grid>
  )
}

export default IconWidget
